<template lang="html">
  <div class="content-wrapper">
  <div class="row">
    <!-- <button v-if='big_subscription' class="big-subscription" v-on:click="confirmBigsubscription()"><i class="fas fa-shopping-bag fa-fw"></i>{{isChecked==true?"Make subscription":"Make subscription"}}</button> -->
    <button v-if='$parent.plan_status>1' class="big-subscription">{{current_trading_count +"/"+ ($parent.plan_status - 1) +" bots" }}</button>
    <div class="col-sm-12 grid-margin">
      <div class="row">
        <div class="col-sm-12 pr-0">
          <div>
            <h3 class="text-light font-weight-bold mb-0 mr-5">{{lang=="ru"?"Список ботов":"Welcome to Bots Market"}}</h3>
            <!-- <div class="filter_btns">
              <router-link :to="'?filter='+tag" class="badge badge-primary" v-for="tag in all_tags"> {{tag}} </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:center; width:100%">
      <button class='btn btn-secondary' @click="filter_category('long_4h')" :style="category=='long_4h'?'background: #323232':''">Long 4H</button>
      <button class='btn btn-secondary' @click="filter_category('long_1h')" :style="category=='long_1h'?'background: #323232 ':''">Long 1H</button>
      <button class='btn btn-secondary' @click="filter_category('short')" :style="category=='short'?'background: #323232 ':''">Short 4H</button>
    </div>
  </div>
  <div  :class="category=='long'? '':(category=='short'?'':(this.$route.query.filter?'':'invisible'))" @click="bots_reload()" style="cursor: pointer; color: #464dee">&lt; {{lang=="ru"?"Все стратегии":"All strategies"}}<br/><br/></div>
  <div class="row">
    <div class="col-lg-6" >
      <StrategyCard :big_subscription="big_subscription" :isChecked="isChecked"  v-for="strategy in column1" :checkbots="checkbots" v-model="checkbots[strategy.id]" :key="strategy.id" :strategy="strategy" :connections="$parent.subscriptions.filter(sub => (sub.strategy_id == strategy.id))"/>
    </div>
    <div class="col-lg-6">
      <StrategyCard :big_subscription="big_subscription" :isChecked="isChecked"  v-for="strategy in column2" :checkbots="checkbots" v-model="checkbots[strategy.id]" :key="strategy.id" :strategy="strategy" :connections="$parent.subscriptions.filter(sub => (sub.strategy_id == strategy.id))"/>
    </div>
  </div>
  <b-modal v-model="confirmBigsubscriptionModal">
    <template v-slot:modal-title>
      {{lang=="ru"?"Подтвердить подписку":"Confirm big subscription"}}
    </template>
    <b-alert show variant='danger' v-if='$parent.balance < 40'><b>Not enough funds for subscription </b><router-link to='/dashboard/settings' target='_blank'>Please, refill your balance <i class="fas fa-external-link-alt"></i></router-link></b-alert>
    <p style='text-align: center;' v-else v-for="str in prefered_strategies">Strategy <b>{{str.title}}</b> with asset <b>{{str.preferred_pair}} {{formatTimeframe(str.preferred_timeframe)}}</b>.<br>
    </p>
    <p style='text-align: center;' v-if='$parent.balance>= 40'>{{lang=="ru"?"Цена":"Price"}}: $40 {{lang=="ru"?"в месяц":"per month"}} <br><b>{{lang=="ru"?"Все верно?":"All correct?"}}</b></p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Отмена":"Cancel"}}</b-button>
      <b-button variant='primary' @click='saveBigsubscription()' v-if='$parent.balance>= 40'> {{lang=="ru"?"Подтвердить":"Confirm"}} </b-button>
    </template>
  </b-modal>
  <b-modal v-model='bigSubscriptionAskModal'>
    <template v-slot:modal-title>
      <h2>Notification</h2>
    </template>
    <p style='text-align: center'>
       {{lang=="ru"?"Пожалуйста укажите 4 стратегии, на которые вы хотели бы подписаться":"Please select 4 strategies, which you would like to subscribe"}}
    </p>
    <h2 style="text-align:center; margin-top:20px">40$</h2>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Отменить":"Cancel"}}</b-button>
      <b-button variant='primary' @click='showCheckbox()'> {{lang=="ru"?"Хорошо":"OK"}} </b-button>
    </template>
  </b-modal>
</div>
</template>

<script>
import StrategyCard from './StrategyCard'
export default {
  data () {
    return {
      column1: [],
      column2: [],
      all_tags:[],
      lang:'en',
      big_subscription:1,
      confirmBigsubscriptionModal:false,
      prefered_strategies:[],
      total_colume:[],
      check_count:[],
      isChecked:false,
      checkbots:{},
      bigSubscriptionAskModal:false,
      current_trading_count:0,
      category:"all"
    }
  },
  mounted(){
    this.$root.$on("checkedbots", () => {
      return this.checkeBotArray();
    });
  },
  components: {
    StrategyCard
  },
  created () {
    this.loadStrategies()
    this.getTags();
    this.check_bigsubscriptoin();
    this.count_trading();
    // this.get_profered_strategy();
    this.lang = this.$cookie.get('lang');
    var select_bot_id=this.$route.query.big_bot_id;
    var savedBots={'37':false};
    if(select_bot_id){
      if(this.$cookie.get('checked_bots')){
        savedBots=JSON.parse(this.$cookie.get('checked_bots'));
      }
      this.isChecked=true
      savedBots[select_bot_id]=true;
      document.cookie = 'checked_bots=' +JSON.stringify(savedBots)+ ';path=/;domain=tradingapp.pro;'
    }else{
       document.cookie = 'checked_bots=' +JSON.stringify(savedBots)+ ';path=/;domain=tradingapp.pro;'
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.column1 = []
    this.column2 = []
    this.loadStrategies()
    this.count_trading()
  },
  methods: {
      bots_reload(){
        if(this.$route.query.filter || this.$route.query.category){
          window.location.replace("https://tradingapp.pro/app/#/dashboard/market")
        }else{
          window.location.reload()
        }

      },
      filter_category(cat){
        this.category=cat
        this.axios.post('/strategies/filter_category',{
          category:cat
        },{withCredentials: true})
        .then((strategies) => {
          var filter_arr=[];
          var othter_strs_arr=[];
          var total_strategies=strategies.data
          for (var t=0; t<total_strategies.length; t++){
            if(total_strategies[t].plan_status==1){
              filter_arr.push(total_strategies[t])
            }else{
              othter_strs_arr.push(total_strategies[t])
            }
          }
          console.log("=======plan status===========")
          console.log(this.$parent.plan_status)
          if(this.$parent.plan_status==1){
            total_strategies=filter_arr.concat(othter_strs_arr)
            console.log("=====================cat filtered data======================")
            console.log(total_strategies)
          }
          this.column1=[];
          this.column2=[];
          for (var i = 0; i < total_strategies.length; i++) {
            if ((i + 2) % 2 === 0) {
              this.column1.push(total_strategies[i])
            } else {
              this.column2.push(total_strategies[i])
            }
            console.log("============cat column================")
            console.log(this.column1)
            console.log(this.column2)
            this.total_colume.push(total_strategies[i]);
          }
      })
      },
      count_trading(){
        this.axios.get('/user/overview', {withCredentials: true})
        .then((userInfo) => {
          userInfo = userInfo.data
          var subscriptions = userInfo.subscriptions
          console.log(subscriptions)
          var total_count = 0;
          for (var i = 0; i < subscriptions.length; i++){
            var subscription=subscriptions[i];
            if(subscription.autotrade || subscription.percent_usdt){
              total_count++
            }
          }
          this.current_trading_count=total_count
        })
      },
      checkeBotArray(){
        document.cookie = 'checked_bots=' +JSON.stringify(this.checkbots)+ ';path=/;domain=tradingapp.pro;'
      },
      saveBigsubscription () {
        this.axios.post('/subscription/add_big_subscription', {
          bot_ids:this.check_count
        },{withCredentials: true}).then(response => {
          console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            this.$router.push('/dashboard/overview')
            this.$root.$bvToast.toast('Saved successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
          })
        }
      })
    },
    formatTimeframe (tf) {
      var intTF = parseInt(tf)
      if (intTF < 60) return tf + 'm'
      if (intTF < 1440) return (intTF / 60).toString() + 'h'
      if (intTF < 10080) return (intTF / 1440).toString() + 'D'
      if (intTF < 43200) return (intTF / 10080).toString() + 'W'
    },
    loadStrategies () {
      this.total_colume=[];
      if(this.$route.query.filter==null || this.$route.query.filter==undefined || this.$route.query.filter==''){
        this.category="all";
      }
      var select_id=this.$route.query.big_bot_id;
      var saved_Bots=JSON.parse(this.$cookie.get('checked_bots'));
      const apath = this.$route.query.filter ? '/strategies/search?tag=' + this.$route.query.filter +'&category='+this.$route.query.category : '/strategies/all'
      console.log(apath)
      this.axios.get(apath)
        .then((strategies) => {
          var filter_arr=[];
          var othter_strs_arr=[];
          var total_strategies=strategies.data
          for (var t=0; t<total_strategies.length; t++){
            if(total_strategies[t].plan_status==1){
              filter_arr.push(total_strategies[t])
            }else{
              othter_strs_arr.push(total_strategies[t])
            }
          }
          console.log("=======plan status===========")
          console.log(this.$parent.plan_status)
          if(this.$parent.plan_status==1){
            total_strategies=filter_arr.concat(othter_strs_arr)
            console.log("=====================filtered data======================")
            console.log(total_strategies)
          }
          for (var i = 0; i < total_strategies.length; i++) {
              total_strategies[i]['check_bot']=false
              if(select_id){
                for (const [key, value] of Object.entries(saved_Bots)) {
                  if(key==total_strategies[i]['id']){total_strategies[i]['check_bot']=value}
                }
                if(total_strategies[i]['id']==select_id){total_strategies[i]['check_bot']=true}
              }
            if ((i + 2) % 2 === 0) {
              this.column1.push(total_strategies[i])
            } else {
              this.column2.push(total_strategies[i])
            }
            console.log("============column================")
            console.log(this.column1)
            console.log(this.column2)
            this.total_colume.push(total_strategies[i]);
          }
        })
    },
    
    isChecked () {
      this.isChecked = true
    },

    confirmBigsubscription () {
      if (this.isChecked === true) {
        var status = 0
        this.check_count = []
        this.prefered_strategies = []
        for (var i = 0; i < this.total_colume.length; i++) {
          var checkBots = this.total_colume[i]
          if (checkBots.check_bot === true) {
            this.check_count.push(checkBots.id)
            this.prefered_strategies.push(checkBots)
          }
          if (i === this.total_colume.length - 1) {
            status = 1
          }
        }
        if (status === 1) {
          if (this.check_count.length === 4) {
            this.confirmBigsubscriptionModal = true
          } else {
            this.$root.$bvToast.toast('You can only select 4 bots for big subscription ', {
              title: 'Notification',
              variant: 'warning',
              solid: true
            })
          }
        }
      } else {
        this.bigSubscriptionAskModal = true
        // this.isChecked=true
      }
    },

    showCheckbox () {
      this.isChecked = true
      this.bigSubscriptionAskModal = false
    },

    check_bigsubscriptoin () {
      this.axios.get('/subscription/check_bigsubscription', {
        withCredentials: true
      })
        .then((response) => {
          if (response.data.success) {
            this.big_subscription = 0
          }
        })
    },

    getTags () {
      this.axios.get('/strategies/get_tags', {
        withCredentials: true
      })
        .then((response) => {
          var tagData = []
          for (var i = 0; i < response.data.length; i++) {
            var tg = response.data[i]
            tagData.push(tg.name)
          }
          this.all_tags = tagData
        })
    }
  }
}
</script>

<style lang="css" scoped>
  .filter_btns{
    margin-left: 30px;
  }
  .filter_btns .badge{
    margin-right: 10px;
    margin-top: 10px;
  }
  .etc_tag_btn{
    margin-bottom: 0;
  }
  .etc_tag_btn:hover{
    cursor: pointer;
  }
  .router-link-exact-active{
    background-color: #1720EA;
  }
  .big-subscription{
     background:transparent; color: white;padding: 10px;border: none; position: absolute;right: 30px; cursor: pointer;z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/components/MarketView.vue